import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/app/components/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Shell.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource-variable/geist/index.css");
